import { useMemo } from "react";

import { getAppEnvironment } from "@/config/app-environment";
import { getFeatureFlags } from "@/config/features";

/** The debug borders and chips are switched off for now. The Debug button keeps its other uses. */
const BOARD_DEBUG_DRAWING: boolean = false;

export function useBookTimelineBoardDebug(
  boardModelDebug: boolean,
): { featureFlags: ReturnType<typeof getFeatureFlags>; boardDebugActive: boolean } {
  const featureFlags = useMemo(
    () => getFeatureFlags(getAppEnvironment()),
    [],
  );
  const boardDebugActive = BOARD_DEBUG_DRAWING
    && boardModelDebug
    && featureFlags.boardModelDebugMenu;
  return { featureFlags, boardDebugActive };
}
